class OneParkService {
  constructor(client) {
    this.apiClient = client;
  }

  async getAdminSettings(facilityID) {
    return await this.apiClient.get(`onepark/${facilityID}/admin/settings`);
  }

  async saveAdminSettings(facilityID, settings) {
    return await this.apiClient.put(
      `onepark/${facilityID}/admin/settings`,
      settings
    );
  }

  async uploadLogo(facilityID, formData) {
    return await this.apiClient.post(
      `onepark/${facilityID}/admin/logo`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  }

  async getLogo(facilityID) {
    return await this.apiClient.get(`onepark/${facilityID}/admin/logo`);
  }
}

export default OneParkService;
